export default "__VITE_ASSET__DQmYIB1W__"